import { BusinessInvite } from '../../services/model/inviteService.model';
import useSelectedBusiness from './useSelectedBusiness';

export default function useBusinessInvite(): BusinessInvite | undefined {
  return useSelectedBusiness()?.inviteFields;
}
